import { useEffect } from "react";
import { useLocalStorage } from "react-use";

type Feature = "sandbox-curl-session" | "transaction-flow-run-section" | "";

type UseHighlightNewFeatureOptions = {
  /**
   * @default true
   */
  enabled?: boolean;
  once?: boolean;
};

const HIGHLIGHT_DURATION = 10000; // 10 seconds

export function useHighlightNewFeature(
  featureName: Feature,
  options?: UseHighlightNewFeatureOptions
) {
  const { enabled = true, once = false } = options || {};
  const [hasSeenBefore, setHasSeenBefore] = useLocalStorage(
    `feat:${featureName}`,
    false
  );
  useEffect(() => {
    if (!enabled || hasSeenBefore) return;

    const timerId = setTimeout(() => {
      setHasSeenBefore(true);
    }, HIGHLIGHT_DURATION);

    return () => clearTimeout(timerId);
  }, [enabled, hasSeenBefore, setHasSeenBefore]);

  return {
    tooltipOpen: !hasSeenBefore ? true : once ? false : undefined,
    userInteract: () => setHasSeenBefore(true),
    highlightClass: !hasSeenBefore
      ? "border-info-bold ring-2 ring-info-bold/50 animate-pulse duration-2000"
      : "",
  } as const;
}
